import { deepClone } from "@mui/x-data-grid/utils/utils";
import { inPlaygroundMode, labelMappings } from "../../features/manageCoupons/utils/utils"
import { manageCouponInitialStateType } from "../../features/manageCoupons/types"
const initialState: manageCouponInitialStateType = {
    configData: {
        currentTab: '0'
    },
    data:{
        isSchemePlayground : (localStorage[inPlaygroundMode] && localStorage[inPlaygroundMode] === "true") ? true : false,
        couponId : '',
        couponTypeOption:"",
        schemeType:"",
        couponTitle:"",
        skipMarketSelection:false,
        isOverAndAbove:false,
        schemeProductBifurcationsList:[],
        mustBuy:{
            active:false,
            quantityUnit:labelMappings["quantity-unit-value-piece"],
            data:[]
        },
        couponEditType : "",
        deleteParent:false,
        slabInfo:{
            slabUnit:labelMappings['applicable-slab-value'],
            quantityUnit: labelMappings["quantity-unit-value-piece"],
            data: []
        },
        schemeLocationBifurcationsList:[],
        schemeOutletBifurcationsList:[],
        sectionEnabled:{
            "couponTypeOptions":true,
            "couponSchemeType":true,
            "schemeProductBifurcationsList":false,
            "mustBuy":false,
            "banner":false,
            "applicableSlab":false,
            "marketDetails":true,
            "inclusionList":true,
            "exclusionList":true,
        },
        usabilityLimits:{
            "startDate":null,
            "endDate":null,
            "useOnce":false,
            "percentageMaxAmount":"",
        },
        exclusionData:{
            file:null,
            list:[]
        },
        inclusionData: {
            file: null,
            list: []
        },
        recurrence: {
            dateStartEnd: { startDate: null, endDate: null },// start and end date for the coupon
            activePeriodCustomDates: [],// selected active dates
            activePeriodDays: [],// select ed active days
            activePeriodWeeks: [],// selected active weeks
            activePeriodMonths: [],// selected active months
            isActivePeriodSaved: false,// is the activeperiod saved
            savedCalendar: "",
            usabilityLimit: "",// is the limit for that usability period
            usability: "",//is the usability period
            orderResetFrequency: "",// period for with the orders can be placed
            nDaysFromActivation: "",// number of days from start till when the coupn will be active
            numberOfPurchases: "",// number of orders that need be placed for re activation
            couponLife: "",// total times the coupon can be used
            skipUsability: false,
            skipNthOrder: true,
            skipActivePeriod: false,
            skipCouponLife: false,
            couponTimings:[],
            iniUsabilityLimit: "",// is the limit for that usability period
            iniUsability: "",//is the usability period
            iniCouponLife: "",// total times the coupon can be placed
            initialUsabilityFilled:false
        },
        banner:{
            uploadBanner:{
                imageUrl:null,
                bannerPriority:"1",
                active:false
            }
        },
        isPeriodWelcome:false,
        inclusionFileUrl: "",
        exclusionFileUrl: "",
    }
}


export const manageCouponReducer = (state: any = deepClone(initialState), action: { payload: any, type: string }) => {
    switch (action.type) {
        case 'activePeriodCustomDates': return {
            ...state,
            data: {
                ...state.data,
                recurrence: {
                    ...state.data.recurrence,
                    activePeriodCustomDates: action.payload
                }
            }
        }
        case 'activePeriodDays': return {
            ...state,
            data: {
                ...state.data,
                recurrence: {
                    ...state.data.recurrence,
                    activePeriodDays: action.payload
                }
            }
        }
        case 'activePeriodWeeks': return {
            ...state,
            data: {
                ...state.data,
                recurrence: {
                    ...state.data.recurrence,
                    activePeriodWeeks: action.payload
                }
            }
        }
        case 'activePeriodMonths': return {
            ...state,
            data: {
                ...state.data,
                recurrence: {
                    ...state.data.recurrence,
                    activePeriodMonths: action.payload
                }
            }
        }
        case 'isActivePeriodSaved': return {
            ...state,
            data: {
                ...state.data,
                recurrence: {
                    ...state.data.recurrence,
                    isActivePeriodSaved: action.payload
                }
            }
        }
        case 'savedCalendar': return {
            ...state,
            data: {
                ...state.data,
                recurrence: {
                    ...state.data.recurrence,
                    savedCalendar: action.payload
                }
            }
        }
        case 'usabilityLimit': return {
            ...state,
            data: {
                ...state.data,
                recurrence: {
                    ...state.data.recurrence,
                    usabilityLimit: action.payload
                }
            }
        }
        case 'UpdateSkipUsability': return {
            ...state,
            data: {
                ...state.data,
                recurrence: {
                    ...state.data.recurrence,
                    skipUsability: action.payload
                }
            }
        }
        case 'UpdateSkipNthOrder': return {
            ...state,
            data: {
                ...state.data,
                recurrence: {
                    ...state.data.recurrence,
                    skipNthOrder: action.payload
                }
            }
        }
        case 'UpdateSkipActivePeriod': return {
            ...state,
            data: {
                ...state.data,
                recurrence: {
                    ...state.data.recurrence,
                    skipActivePeriod: action.payload
                }
            }
        }
        case 'UpdateSkipCouponLife': return {
            ...state,
            data: {
                ...state.data,
                recurrence: {
                    ...state.data.recurrence,
                    skipCouponLife: action.payload
                }
            }
        }
        case 'usability': return {
            ...state,
            data: {
                ...state.data,
                recurrence: {
                    ...state.data.recurrence,
                    usability: action.payload
                }
            }
        }
        case 'updateDateStartEnd':
            const { field, value } = action.payload;
            return {
                ...state,
                data: {
                    ...state.data,
                    recurrence: {
                        ...state.data.recurrence,
                        dateStartEnd: {
                            ...state.data.recurrence.dateStartEnd,
                            [field]: value
                        }
                    }
                }
            }
        //  case 'updateUsabilityLimits':return{
        //     ...state,
        //     data:{
        //         ...state.data,
        //         usabilityLimits:{
        //             ...action.payload
        //         }
        //     }
        // }
        case 'orderResetFrequency': return {
            ...state,
            data: {
                ...state.data,
                recurrence: {
                    ...state.data.recurrence,
                    orderResetFrequency: action.payload
                }
            }
        }
        case 'nDaysFromActivation': return {
            ...state,
            data: {
                ...state.data,
                recurrence: {
                    ...state.data.recurrence,
                    nDaysFromActivation: action.payload
                }
            }
        }
        case 'numberOfPurchases': return {
            ...state,
            data: {
                ...state.data,
                recurrence: {
                    ...state.data.recurrence,
                    numberOfPurchases: action.payload
                }
            }
        }

        case 'couponLife': return {
            ...state,
            data: {
                ...state.data,
                recurrence: {
                    ...state.data.recurrence,
                    couponLife: action.payload
                }
            }
        }

        case 'updateCouponTypeOptions': return {
            ...state,
            data: {
                ...state.data,
                couponTypeOption: action.payload
            }
        }

        case 'updateIsPeriodWelcome' : return {
            ...state , 
            data:{
                ...state.data,
                isPeriodWelcome: action.payload
            }
        }
        
        case 'updateSchemeType': return {
            ...state,
            data: {
                ...state.data,
                schemeType: action.payload
            }
        }

        case 'updateSchemeProductBifurcationsList': return {
            ...state,
            data: {
                ...state.data,
                schemeProductBifurcationsList: [
                    ...action.payload
                ]
            }
        }

        case 'updateMustBuyData': return {
            ...state,
            data: {
                ...state.data,
                mustBuy: {
                    ...state.data.mustBuy,
                    data: [...action.payload]
                }
            }
        }
        case 'updateMustBuyActive': return {
            ...state,
            data: {
                ...state.data,
                mustBuy: {
                    ...state.data.mustBuy,
                    active: action.payload
                }
            }
        }

        case 'updateSlabInfoData': return {
            ...state,
            data: {
                ...state.data,
                slabInfo: {
                    ...state.data.slabInfo,
                    data: [...action.payload]
                }
            }
        }

        case 'updateSlabInfoUnit': return {
            ...state,
            data: {
                ...state.data,
                slabInfo: {
                    ...state.data.slabInfo,
                    slabUnit: action.payload
                }
            }
        }

        case 'updateMustBuyQuantityUnit': return {
            ...state,
            data: {
                ...state.data,
                mustBuy: {
                    ...state.data.mustBuy,
                    quantityUnit: action.payload
                }
            }
        }

        case 'updateSlabInfoQuantityUnit': return {
            ...state,
            data: {
                ...state.data,
                slabInfo: {
                    ...state.data.slabInfo,
                    quantityUnit: action.payload
                }
            }
        }

        case 'updateSchemeLocationBifurcationsList': return {
            ...state,
            data: {
                ...state.data,
                schemeLocationBifurcationsList: [
                    ...action.payload
                ]
            }
        }


        case 'updateSchemeOutletBifurcationsList': return {
            ...state,
            data: {
                ...state.data,
                schemeOutletBifurcationsList: [
                    ...action.payload
                ]
            }
        }

        case 'updateSectionEnabled': return {
            ...state,
            data: {
                ...state.data,
                sectionEnabled: {
                    ...action.payload
                }
            }
        }

        case 'updateUsabilityLimits': return {
            ...state,
            data: {
                ...state.data,
                usabilityLimits: {
                    ...action.payload
                }
            }
        }

        case 'deleteSKUGroupItem': return {
            ...state,
            data: {
                ...state.data,
                skuGroup: {
                    ...action.payload
                }
            }
        }

        case 'setEntities': return {
            ...state,
            configData: {
                ...state.configData,
                entities: [...action.payload]
            }
        }

        case 'setALLPRODUCTS': return {
            ...state,
            configData: {
                ...state.configData,
                ALL_PRODUCTS: [...action.payload]
            }
        }

        case 'setMarketLevelTabsList': return {
            ...state,
            configData: {
                ...state.configData,
                marketLevelTabsList: [...action.payload]
            }
        }

        case 'setOutletLevelTabsList': return {
            ...state,
            configData: {
                ...state.configData,
                outletLevelTabsList: [...action.payload]
            }
        }

        case 'resetSchemeType': return {
            ...state,
            data: {
                ...state.data,
                schemeType: "",
            }
        }
        case 'resetCouponTypeOption': return {
            ...state,
            data: {
                ...state.data,
                couponTypeOption: "",
            }
        }

        case 'resetSchemeProductBifurcationsList': return {
            ...state,
            data: {
                ...state.data,
                schemeProductBifurcationsList: []
            }
        }

        case 'resetMustBuy': return {
            ...state,
            data: {
                ...state.data,
                mustBuy: {
                    active: false,
                    data: [],
                    quantityUnit: labelMappings["quantity-unit-value-piece"],
                },
            }
        }

        case 'resetSlabInfo': return {
            ...state,
            data: {
                ...state.data,
                slabInfo: {
                    slabUnit: labelMappings['applicable-slab-value'],
                    quantityUnit: labelMappings["quantity-unit-value-piece"],
                    data: []
                }
            }
        }
        case 'resetSectionEnabled': return {
            ...state,
            data: {
                ...state.data,
                sectionEnabled:{
                    "couponTypeOptions":true,
                    "couponSchemeType":true,
                    "schemeProductBifurcationsList":false,
                    "mustBuy":false,
                    "applicableSlab":false
                },
            }
        }


        case 'updateCurrentTab': return {
            ...state,
            configData: {
                ...state.configData,
                currentTab: action.payload
            }
        }

        case 'resetAllData': return {
            ...state,
            data: deepClone({ ...initialState.data })
        }

        case 'updateInclusionData': return {
            ...state,
            data: {
                ...state.data,
                inclusionData: {
                    file: action.payload.file,
                    list: [...action.payload.list]
                }
            }
        }

        case 'updateExclusionData': return {
            ...state,
            data: {
                ...state.data,
                exclusionData: {
                    file: action.payload.file,
                    list: [...action.payload.list]
                }
            }
        }


        case 'resetInclusionData': return {
            ...state,
            data: {
                ...state.data,
                inclusionData: {
                    file: null,
                    list: []
                }
            }
        }

        case 'resetExclusionData': return {
            ...state,
            data: {
                ...state.data,
                exclusionData: {
                    file: null,
                    list: []
                }
            }
        }

        case 'switchPlaygroundMode':return{
            ...state,
            data:{
                ...state.data,
                isSchemePlayground : action.payload
            }
        }

        case 'reinitialiseCouponState':{
            action.payload.configData['currentTab'] = '0';
            return{
            ...state,
            ...action.payload,
            
            }
        }
        
        case 'updateSkipMarketSelection': return {
            ...state,
            data:{
                ...state.data,
                skipMarketSelection:action.payload,
            }
        }
        case 'cloneWholeScheme' :return{
            ...state,
            configData:{
                ...state.configData,
                ...action.payload.configData
            },
            data: {
                ...state.data,
                slabInfo: {
                    ...state.data.slabInfo,
                    open: true,
                },
                ...action.payload.data,
            },
        }

        case 'reinitialiseCurrentTab':{
            return{
            ...state,
            configData : {
                ...state.configData,
                'currentTab' : '0'
            }
            }
        }
        
        case 'updateCouponTitle' : return {
            ...state , 
            data:{
                ...state.data,
                couponTitle: action.payload
            }
        }
        case 'updateIsOverAndAbove' :return{
            ...state,
            data:{
                ...state.data,
                isOverAndAbove:action.payload
            }
        }

        case 'setPercentageMaxAmount': return {
            ...state,
            data:{
                ...state.data,
                usabilityLimits:{
                    ...state.data.usabilityLimits,
                    percentageMaxAmount: action.payload
                }
            }
        }

        case 'updatePlayGroundMode': return {
            ...state,
            data:{
                ...state.data,
                isSchemePlayground:action.payload
            }
        }

        case 'updateUploadBannerImage':return{
            ...state, 
            data:{
                ...state.data,
                banner:{
                    ...state.data.banner,
                    uploadBanner:{
                        ...state.data.banner.uploadBanner,
                        imageUrl:action.payload,
                    }
                }
            }
        }
        case 'updateBannerActive': return {
            ...state,
            data:{
                ...state.data,
                banner:{
                    ...state.data.banner,
                    uploadBanner:{
                        ...state.data.banner.uploadBanner,
                        active : action.payload
                    }
                }
            }
        }

        case 'updateUploadBannerPriority':return{
            ...state, 
            data:{
                ...state.data,
                banner:{
                    uploadBanner:{
                        ...state.data.banner.uploadBanner,
                        bannerPriority:action.payload
                    }
                }
            }
        }

        case 'updateDeleteParent': return {
            ...state,
            data:{
                ...state.data,
                deleteParent:action.payload
            }
        }

        case 'updateQuantityUnit': return {
            ...state,
            data:{
                ...state.data,
                mustBuy:{
                    ...state.data.mustBuy,
                    quantityUnit: action.payload
                }
            }
        }


        case 'updateCouponTimings':return{
            ...state,
            data:{
                ...state.data,
                recurrence: {
                    ...state.data.recurrence,
                    couponTimings: action.payload
                }
            }
        }

        case 'updateInitialUsabilityFilled':return{
            ...state,
            data:{
                ...state.data,
                recurrence: {
                    ...state.data.recurrence,
                    updateInitialUsabilityFilled: action.payload
                }
            }
        }
        case 'updateIniUsability':return{
            ...state,
            data:{
                ...state.data,
                recurrence: {
                    ...state.data.recurrence,
                    updateIniUsability: action.payload
                }
            }
        }
        case 'updateIniUsabilityLimit':return{
            ...state,
            data:{
                ...state.data,
                recurrence: {
                    ...state.data.recurrence,
                    updateIniUsabilityLimit: action.payload
                }
            }
        }

        case 'saveInclusionFileUrl':return {
            ...state,
            data:{
                ...state.data,
                inclusionFileUrl: action.payload
            }
        }

        case 'saveExclusionFileUrl':return {
            ...state,
            data:{
                ...state.data,
                exclusionFileUrl: action.payload
            }
        }

        default: return state;
    }
}

